<template>
  <div class="sys-notice page">
    <van-nav-bar :title="$t('mine.notice')" class="nav-bar" :border="false">
      <template #left>
        <van-icon name="arrow-left" @click="$router.go(-1)" />
      </template>
    </van-nav-bar>

    <div class="content">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <div class="notice-card" v-for="(v, key) in list" :key="v.id || key">
          <div class="notice-head">
            <div class="notice-title">{{ v.name }}</div>
            <div class="notice-time" v-if="v.create_time">{{ v.create_time }}</div>
          </div>
          <div class="notice-body">{{ v.text }}</div>
        </div>
        <van-empty
          v-if="!list.length && !isLoading"
          :description="$t('withdraw.empty_data')"
        />
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SysNotice',
  data() {
    return {
      isLoading: false,
      list: [],
    }
  },
  methods: {
    getList() {
      this.$http({
        method: 'get',
        url: 'sys_get_notice_list',
      })
        .then((res) => {
          this.list = res.data || []
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
        })
    },
    onRefresh() {
      this.getList()
      this.$toast(this.$t('reservation.refresh'))
    },
  },
  created() {
    this.getList()
  },
}
</script>

<style lang="less" scoped>
.sys-notice {
  min-height: 100vh;
  background: #f5f5f5;
  padding-bottom: 16vw;
}

.nav-bar {
  background: #fff !important;

  /deep/ .van-nav-bar__title {
    color: #111;
    font-weight: 600;
  }

  /deep/ .van-icon {
    color: #333;
    font-size: 20px;
  }
}

.content {
  padding: 3.2vw;
  box-sizing: border-box;
}

.notice-card {
  background: #fff;
  border-radius: 2.4vw;
  padding: 3.6vw 4vw;
  margin-bottom: 3.2vw;
}

.notice-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 2vw;
  margin-bottom: 2vw;
}

.notice-title {
  flex: 1;
  font-size: 4vw;
  color: #222;
  font-weight: 600;
  line-height: 1.4;
}

.notice-time {
  flex-shrink: 0;
  font-size: 3.2vw;
  color: #999;
  line-height: 1.4;
}

.notice-body {
  font-size: 3.733vw;
  line-height: 1.65;
  color: #555;
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
